import { render } from "./NcrmPrivacyPairsCard.vue?vue&type=template&id=2ecd4296&scoped=true"
import script from "./NcrmPrivacyPairsCard.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPairsCard.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPairsCard.vue?vue&type=style&index=0&id=2ecd4296&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecd4296"]])

export default __exports__